import { Flex } from 'antd';
import styled from 'styled-components';
import { ImageContainer } from '../../../../styles/commonStyles';

export const StepImageContainer = styled(ImageContainer)`
  width: 90%;
  height: 100%;
  max-width: 800px;
  max-height: 480px;
  .ant-image-img {
    height: auto !important;
  }
`;

export const RoutineSigns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
`;

export const RoutineSignImage = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;

export const StepSigns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
`;

export const StepSignImage = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;
